const PASSWORD_REGEXP = new RegExp(
  '^(?=.{6,})(?=.*[A-Z])((?=.*[0-9])|(?=.*[@#$%^&+=])).*'
);

const CRYPTO_SECRET_KEY = '98EDFD4AE52A1627E71D567E7B116';
export { PASSWORD_REGEXP, CRYPTO_SECRET_KEY };
